export default "__VITE_ASSET__1eb36564__"